/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EmrCluster } from '../model/emrCluster';
import { EmrClusterCreateRequest } from '../model/emrClusterCreateRequest';
import { EmrHadoopJarStep } from '../model/emrHadoopJarStep';
import { EmrHadoopJarStepAddRequest } from '../model/emrHadoopJarStepAddRequest';
import { EmrHiveStep } from '../model/emrHiveStep';
import { EmrHiveStepAddRequest } from '../model/emrHiveStepAddRequest';
import { EmrPigStep } from '../model/emrPigStep';
import { EmrPigStepAddRequest } from '../model/emrPigStepAddRequest';
import { EmrShellStep } from '../model/emrShellStep';
import { EmrShellStepAddRequest } from '../model/emrShellStepAddRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class EMRService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addHadoopJarStepToEmrCluster
     * Adds a Hadoop Jar step to the existing cluster &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param emrHadoopJarStepAddRequest the information needed to add Hadoop Jar step to the EMR cluster.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRAddHadoopJarStepToEmrCluster(emrHadoopJarStepAddRequest: EmrHadoopJarStepAddRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrHadoopJarStep>;
    public eMRAddHadoopJarStepToEmrCluster(emrHadoopJarStepAddRequest: EmrHadoopJarStepAddRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrHadoopJarStep>>;
    public eMRAddHadoopJarStepToEmrCluster(emrHadoopJarStepAddRequest: EmrHadoopJarStepAddRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrHadoopJarStep>>;
    public eMRAddHadoopJarStepToEmrCluster(emrHadoopJarStepAddRequest: EmrHadoopJarStepAddRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (emrHadoopJarStepAddRequest === null || emrHadoopJarStepAddRequest === undefined) {
            throw new Error('Required parameter emrHadoopJarStepAddRequest was null or undefined when calling eMRAddHadoopJarStepToEmrCluster.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmrHadoopJarStep>(`${this.configuration.basePath}/emrHadoopJarSteps`,
            emrHadoopJarStepAddRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * addHiveStepToEmrCluster
     * Adds a hive step to the existing cluster &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param emrHiveStepAddRequest the information needed to add hive step to the EMR cluster.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRAddHiveStepToEmrCluster(emrHiveStepAddRequest: EmrHiveStepAddRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrHiveStep>;
    public eMRAddHiveStepToEmrCluster(emrHiveStepAddRequest: EmrHiveStepAddRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrHiveStep>>;
    public eMRAddHiveStepToEmrCluster(emrHiveStepAddRequest: EmrHiveStepAddRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrHiveStep>>;
    public eMRAddHiveStepToEmrCluster(emrHiveStepAddRequest: EmrHiveStepAddRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (emrHiveStepAddRequest === null || emrHiveStepAddRequest === undefined) {
            throw new Error('Required parameter emrHiveStepAddRequest was null or undefined when calling eMRAddHiveStepToEmrCluster.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmrHiveStep>(`${this.configuration.basePath}/emrHiveSteps`,
            emrHiveStepAddRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * addPigStepToEmrCluster
     * Adds a Pig step to the existing cluster &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param emrPigStepAddRequest the information needed to add Pig step to the EMR cluster.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRAddPigStepToEmrCluster(emrPigStepAddRequest: EmrPigStepAddRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrPigStep>;
    public eMRAddPigStepToEmrCluster(emrPigStepAddRequest: EmrPigStepAddRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrPigStep>>;
    public eMRAddPigStepToEmrCluster(emrPigStepAddRequest: EmrPigStepAddRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrPigStep>>;
    public eMRAddPigStepToEmrCluster(emrPigStepAddRequest: EmrPigStepAddRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (emrPigStepAddRequest === null || emrPigStepAddRequest === undefined) {
            throw new Error('Required parameter emrPigStepAddRequest was null or undefined when calling eMRAddPigStepToEmrCluster.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmrPigStep>(`${this.configuration.basePath}/emrPigSteps`,
            emrPigStepAddRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * addShellStepToEmrCluster
     * Adds a shell step to the existing cluster &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param emrShellStepAddRequest the information needed to add shell step to the EMR cluster.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRAddShellStepToEmrCluster(emrShellStepAddRequest: EmrShellStepAddRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrShellStep>;
    public eMRAddShellStepToEmrCluster(emrShellStepAddRequest: EmrShellStepAddRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrShellStep>>;
    public eMRAddShellStepToEmrCluster(emrShellStepAddRequest: EmrShellStepAddRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrShellStep>>;
    public eMRAddShellStepToEmrCluster(emrShellStepAddRequest: EmrShellStepAddRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (emrShellStepAddRequest === null || emrShellStepAddRequest === undefined) {
            throw new Error('Required parameter emrShellStepAddRequest was null or undefined when calling eMRAddShellStepToEmrCluster.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmrShellStep>(`${this.configuration.basePath}/emrShellSteps`,
            emrShellStepAddRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createEmrCluster
     * Creates a new EMR cluster. &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param emrClusterCreateRequest the information needed to create the EMR cluster.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRCreateEmrCluster(emrClusterCreateRequest: EmrClusterCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrCluster>;
    public eMRCreateEmrCluster(emrClusterCreateRequest: EmrClusterCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrCluster>>;
    public eMRCreateEmrCluster(emrClusterCreateRequest: EmrClusterCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrCluster>>;
    public eMRCreateEmrCluster(emrClusterCreateRequest: EmrClusterCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (emrClusterCreateRequest === null || emrClusterCreateRequest === undefined) {
            throw new Error('Required parameter emrClusterCreateRequest was null or undefined when calling eMRCreateEmrCluster.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmrCluster>(`${this.configuration.basePath}/emrClusters`,
            emrClusterCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getEmrCluster
     * Gets an existing EMR cluster details. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param emrClusterDefinitionName the EMR cluster definition name
     * @param emrClusterName the EMR cluster name
     * @param emrClusterId the cluster id of the cluster to get details
     * @param emrStepId the step id of the step to get details
     * @param verbose parameter for whether to return detailed information
     * @param accountId the account Id
     * @param retrieveInstanceFleets parameter for whether to retrieve instance fleets
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRGetEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, emrClusterId?: string, emrStepId?: string, verbose?: boolean, accountId?: string, retrieveInstanceFleets?: boolean, observe?: 'body', reportProgress?: boolean): Observable<EmrCluster>;
    public eMRGetEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, emrClusterId?: string, emrStepId?: string, verbose?: boolean, accountId?: string, retrieveInstanceFleets?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrCluster>>;
    public eMRGetEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, emrClusterId?: string, emrStepId?: string, verbose?: boolean, accountId?: string, retrieveInstanceFleets?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrCluster>>;
    public eMRGetEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, emrClusterId?: string, emrStepId?: string, verbose?: boolean, accountId?: string, retrieveInstanceFleets?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling eMRGetEmrCluster.');
        }
        if (emrClusterDefinitionName === null || emrClusterDefinitionName === undefined) {
            throw new Error('Required parameter emrClusterDefinitionName was null or undefined when calling eMRGetEmrCluster.');
        }
        if (emrClusterName === null || emrClusterName === undefined) {
            throw new Error('Required parameter emrClusterName was null or undefined when calling eMRGetEmrCluster.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (emrClusterId !== undefined && emrClusterId !== null) {
            queryParameters = queryParameters.set('emrClusterId', <any>emrClusterId);
        }
        if (emrStepId !== undefined && emrStepId !== null) {
            queryParameters = queryParameters.set('emrStepId', <any>emrStepId);
        }
        if (verbose !== undefined && verbose !== null) {
            queryParameters = queryParameters.set('verbose', <any>verbose);
        }
        if (accountId !== undefined && accountId !== null) {
            queryParameters = queryParameters.set('accountId', <any>accountId);
        }
        if (retrieveInstanceFleets !== undefined && retrieveInstanceFleets !== null) {
            queryParameters = queryParameters.set('retrieveInstanceFleets', <any>retrieveInstanceFleets);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EmrCluster>(`${this.configuration.basePath}/emrClusters/namespaces/${encodeURIComponent(String(namespace))}/emrClusterDefinitionNames/${encodeURIComponent(String(emrClusterDefinitionName))}/emrClusterNames/${encodeURIComponent(String(emrClusterName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * terminateEmrCluster
     * Terminates an existing EMR cluster. &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param emrClusterDefinitionName the EMR cluster definition name
     * @param emrClusterName the EMR cluster name
     * @param overrideTerminationProtection parameter for whether to override termination protection
     * @param emrClusterId EMR cluster ID
     * @param accountId account Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRTerminateEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, overrideTerminationProtection?: boolean, emrClusterId?: string, accountId?: string, observe?: 'body', reportProgress?: boolean): Observable<EmrCluster>;
    public eMRTerminateEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, overrideTerminationProtection?: boolean, emrClusterId?: string, accountId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrCluster>>;
    public eMRTerminateEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, overrideTerminationProtection?: boolean, emrClusterId?: string, accountId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrCluster>>;
    public eMRTerminateEmrCluster(namespace: string, emrClusterDefinitionName: string, emrClusterName: string, overrideTerminationProtection?: boolean, emrClusterId?: string, accountId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling eMRTerminateEmrCluster.');
        }
        if (emrClusterDefinitionName === null || emrClusterDefinitionName === undefined) {
            throw new Error('Required parameter emrClusterDefinitionName was null or undefined when calling eMRTerminateEmrCluster.');
        }
        if (emrClusterName === null || emrClusterName === undefined) {
            throw new Error('Required parameter emrClusterName was null or undefined when calling eMRTerminateEmrCluster.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (overrideTerminationProtection !== undefined && overrideTerminationProtection !== null) {
            queryParameters = queryParameters.set('overrideTerminationProtection', <any>overrideTerminationProtection);
        }
        if (emrClusterId !== undefined && emrClusterId !== null) {
            queryParameters = queryParameters.set('emrClusterId', <any>emrClusterId);
        }
        if (accountId !== undefined && accountId !== null) {
            queryParameters = queryParameters.set('accountId', <any>accountId);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmrCluster>(`${this.configuration.basePath}/emrClusters/namespaces/${encodeURIComponent(String(namespace))}/emrClusterDefinitionNames/${encodeURIComponent(String(emrClusterDefinitionName))}/emrClusterNames/${encodeURIComponent(String(emrClusterName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
